/**
 * Register Page
 * Requirements: 6.1
 */
import React from 'react';
import { Box, Container } from '@mui/material';
import { RegisterForm } from '../components';

export const RegisterPage: React.FC = () => {
  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          py: 4,
        }}
      >
        <RegisterForm />
      </Box>
    </Container>
  );
};
